import React from 'react'
import { Box, Typography } from '@material-ui/core'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'

import LoadingSpinner from 'components/loading-spinner'

const PaymentsByMonthChart = ({ data, title, className, loading, error }) => {
  const renderContent = () => {
    if (loading) return <LoadingSpinner />
    if (error) return <Box p={3}>Error loading chart data</Box>
    if (!data?.length) return <Box p={3}>No data available</Box>

    return (
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
            tickFormatter={value => `$${value.toLocaleString()}.00`}
          />
          <Tooltip
            formatter={value => [`$${value.toLocaleString()}.00`, 'Total']}
          />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#2053FF"
            strokeWidth={2}
            dot={{ fill: '#2053FF', r: 4 }}
            activeDot={{ r: 6 }}
            name="Total"
            animationDuration={1800}
            animationBegin={300}
          />
        </LineChart>
      </ResponsiveContainer>
    )
  }

  return (
    <Box className={className}>
      <Typography variant="h6" style={{ marginBottom: '16px' }}>
        {title}
      </Typography>
      <Box style={{ height: 300 }}>{renderContent()}</Box>
    </Box>
  )
}

export default PaymentsByMonthChart
